import { IClient } from '@/shared/model/client.model';
import { IRate } from './company-rate.model';

export interface ICompany {
  id?: string;
  name?: string;
  cif?: string;
  phone?: string;
  city?: string;
  country?: string;
  clients?: IClient[] | null;
  rates?: IRate[] | null;
}

export class Company implements ICompany {
  constructor(
    public id?: string,
    public name?: string,
    public cif?: string,
    public phone?: string,
    public city?: string,
    public country?: string,
    public clients?: IClient[] | null,
    public rates?: IRate[] | null
  ) {}
}

export class Companies extends Array<Company> {
  constructor(data: Company[]) {
    super(...data);
  }

  static empty(): Companies {
    return new Companies([]);
  }

  static from(data: Company[]): Companies {
    if (!data) return null;
    return new Companies(data);
  }

  toIdAndDescription = (): { id: string; desc: string }[] => {
    return this.map(company => ({ id: company.id, desc: company.name }));
  };

  findById = (id: string): Company => {
    return this.find(company => company.id === id);
  };
}
